import React, { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { styled } from '@mui/system';
import { FaBars } from 'react-icons/fa';
import Sidebar from './Sidebar';
import AppColors from '../../utils/AppColors';

const SIDEBAR_OPEN_WIDTH = 240;
const SIDEBAR_CLOSED_WIDTH = 74;

const MainContainer = styled(Box)({
    display: 'flex',
    minHeight: '100vh',
    background: '#F5F7FA',
});

const ContentContainer = styled(Box)(({ sidebaropen }) => ({
    marginLeft: sidebaropen === 'true' ? `${SIDEBAR_OPEN_WIDTH}px` : `${SIDEBAR_CLOSED_WIDTH}px`,
    width: sidebaropen === 'true' ? `calc(100% - ${SIDEBAR_OPEN_WIDTH}px)` : `calc(100% - ${SIDEBAR_CLOSED_WIDTH}px)`,
    transition: 'all 0.25s ease',
    overflow: 'auto',
    minHeight: '100vh',
}));

const Layout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(() => {
        try {
            const saved = localStorage.getItem('jaddid_admin_sidebar_open');
            return saved === null ? true : saved === '1';
        } catch { return true; }
    });

    const toggleSidebar = () => {
        setSidebarOpen((prev) => {
            const next = !prev;
            try { localStorage.setItem('jaddid_admin_sidebar_open', next ? '1' : '0'); } catch {}
            return next;
        });
    };

    return (
        <MainContainer>
            <Sidebar isOpen={sidebarOpen} />
            <ContentContainer sidebaropen={sidebarOpen.toString()}>
                <Tooltip title={sidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'} placement="right">
                    <IconButton
                        onClick={toggleSidebar}
                        sx={{
                            position: 'fixed',
                            top: 14,
                            left: sidebarOpen ? SIDEBAR_OPEN_WIDTH + 12 : SIDEBAR_CLOSED_WIDTH + 8,
                            zIndex: 1100,
                            width: 36,
                            height: 36,
                            backgroundColor: '#fff',
                            color: AppColors.primaryDark,
                            border: '1px solid rgba(14,37,55,0.08)',
                            boxShadow: '0 4px 12px rgba(14,37,55,0.08)',
                            transition: 'all 0.25s ease',
                            '&:hover': { backgroundColor: '#fff', boxShadow: '0 6px 16px rgba(14,37,55,0.14)' },
                        }}
                    >
                        <FaBars size={14} />
                    </IconButton>
                </Tooltip>
                <Box sx={{ pt: { xs: 7, sm: 8 }, px: { xs: 1.5, sm: 2.5 }, pb: 3 }}>
                    {children}
                </Box>
            </ContentContainer>
        </MainContainer>
    );
};

export default Layout;
